import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import ReviewPage from "./ReviewPage";
import FinalPage from "./FinalPage";
import AccountingPage from "./AccountingPage";
import ImportsList from "./ImportsList";
import WeeksList from "./WeeksList";
import ImportPage from "./ImportPage";
import Login from "./Login";
import { useState, useEffect } from "react";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(null); // 👈 null = loading

  const API_BASE_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/api";

  useEffect(() => {
    fetch(`${API_BASE_URL}/me`, {
      credentials: "include",
      cache: "no-store",
    })
      .then(async res => {
        if (!res.ok) {
          // res.ok is true for 2xx status codes
          setLoggedIn(false);
          return;
        }

        const data = await res.json();
        if (data.ok) {
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
        }
      })
      .catch(() => setLoggedIn(false));
  }, []);

  if (loggedIn === null) {
    return <div>Loading...</div>; // or spinner
  }

  return loggedIn ? (
    <BrowserRouter>
      <nav>
        <Link to="/">All imports</Link> |{" "}
        <Link to="/weeks">Weeks</Link> |{" "}
        <Link to="/import">New import</Link> |{" "}
        <Link to="/final">Final Table</Link>
      </nav>

      <Routes>
        <Route path="/" element={<ImportsList />} />
        <Route path="/weeks" element={<WeeksList />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/imports/:id" element={<ImportPage />} />
        <Route path="/weeks/:id" element={<ReviewPage />} />
        <Route path="/accounting/:id" element={<AccountingPage />} />
        <Route path="/final" element={<FinalPage />} />
      </Routes>
    </BrowserRouter>
  ) : (
    <Login onLogin={() => setLoggedIn(true)} />
  );
}
